export const nameRepresentation = (firstName: string, lastName: string) => {
  const sliceLastName = lastName.slice(0, 1) + '.';
  return `${firstName} ${sliceLastName}`;
};

export const sliceWords = (text: string, wordsNumber: number) => {
  const splittedText = text.split(' ');
  const slicedTextArray = splittedText.slice(0, wordsNumber);

  if (splittedText.length <= wordsNumber) {
    return text;
  }
  let slicedText = '';
  slicedTextArray.map(word => {
    slicedText += `${word} `;
  });
  return slicedText;
};
